/**
 * Toggle the state of a boolean
 * @function toggleBool
 * @param {boolean} prevState prev state of boolean
 * @returns {boolean} inverted boolean state
 */
export const toggleBool = (prevState: boolean): boolean => !prevState;
